"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const Root_1 = require("./Root");
const graphql_react_1 = require("graphql-react");
// Instantiate the app.
const graphql = new graphql_react_1.GraphQL();
document.title = "Authorize";
react_dom_1.default.render(react_1.default.createElement(graphql_react_1.GraphQLContext.Provider, { value: graphql },
    react_1.default.createElement(Root_1.Root, { strategies: [require("@authx/strategy-email/interface").default, require("@authx/strategy-password/interface").default, require("@authx/strategy-openid/interface").default, require("@authx/strategy-saml/interface").default] })), document.getElementById("root"));
